






































import Vue from 'vue';
import accountClient from '../apis';
import accountVuex from '../vuex/common';
import moment from 'moment';

export default Vue.extend({
  mixins: [accountVuex],
  data() {
    return {
      moment,
      isHover: false,
      hoverId: 0,
      accountDetails: [],
      logingAccount: null,
    };
  },
  methods: {
    getAllAccountDetail() {
      accountClient.getAllAccountDetail({}).success((r) => {
        this.accountDetails = r;
      });
    },
    authWx() {
      window.open('https://weixin.drip.im/wx-member/auth?origin=' + encodeURIComponent('http://crm.drip.im/api-crm-web/auth/dripCrmAuthCallback') + '&authType=1');
    },
    changeAccount(account: any) {
      accountClient.changeAccount({weixinId: account.weixinId}).success((r) => {
        this.logingAccount = account;
        window.localStorage.setItem('account', JSON.stringify(account));
        this.$store.commit('UPDATE_ACCOUNT', account);
        window.location.href = '#/customer/search';
      });
    },
  },
  mounted() {
    this.getAllAccountDetail();
    this.logingAccount = this.account;
  },
});
